import { Authorship } from '../types';

/**
 * Utility to format authors
 */
export const formatAuthors = (authorships: Authorship[]) => {
    if (!authorships || authorships.length === 0) return 'Unknown Author';
    if (authorships.length === 1) return authorships[0].author.display_name;
    if (authorships.length === 2) return `${authorships[0].author.display_name} & ${authorships[1].author.display_name}`;
    return `${authorships[0].author.display_name} et al.`;
};
